import AdminUser from 'AdminUser';
import BackendService from 'BackendService';
import { debounce } from 'lodash';
import React from 'react';

/**
 * Debounced admin-user search for the guardrail editor's "insert admin as email
 * link" picker. Only admins with an email are returned (they are the ones we can
 * turn into a `mailto:` link).
 */
export function useAdminLinkSearch() {
  const [adminOptions, setAdminOptions] = React.useState<AdminUser[]>([]);
  const [adminLoading, setAdminLoading] = React.useState(false);

  const searchAdmins = React.useMemo(
    () =>
      debounce((term: string) => {
        if (term.trim().length < 2) {
          setAdminOptions([]);
          setAdminLoading(false);
          return;
        }
        setAdminLoading(true);
        new BackendService()
          .searchAdminUser(term.trim())
          .then((results) => setAdminOptions(results.filter((a) => !!a.email)))
          .catch(() => setAdminOptions([]))
          .finally(() => setAdminLoading(false));
      }, 250),
    [],
  );

  React.useEffect(() => () => searchAdmins.cancel(), [searchAdmins]);

  const clearAdminOptions = React.useCallback(() => setAdminOptions([]), []);

  return { adminOptions, adminLoading, searchAdmins, clearAdminOptions };
}
